<div [ngClass]="isPageWithSidebar ? 'with-sidebar' : 'without-sidebar'" class="card newhomepage bg-green-5">
  @if (title) {
    <div class="carousel-header mb-6 text-center text-xl font-medium">{{ title }}</div>
  }

  <div #sliderRef [ngClass]="slider ? 'loaded' : 'not-loaded'" class="card-body keen-slider">
    @for (item of sliderPuffs; let i = $index; track item.id) {
      <div class="keen-slider__slide">
        @switch (item['type']) {
          @case (customPostTypeObjectNameEnum.BLOG) {
            <app-blog-puff
              [forceContentCssClass]="'p-4'"
              [index]="i"
              [numberOfPriorityPuffs]="numberOfPriorityPuffs()"
              [puffDataMultitype]="item"
              [qaHookPreffix]="qaHookPreffix"
            ></app-blog-puff>
          }
          @case (customPostTypeObjectNameEnum.NATIVE) {
            <app-native-puff
              [adNamePreffix]="adNamePreffix"
              [forceContentCssClass]="'p-4'"
              [index]="i"
              [numberOfPriorityPuffs]="numberOfPriorityPuffs()"
              [pageType]="pageType"
              [puffDataMultitype]="item"
              [puffType]="puffType"
              [qaHookPreffix]="qaHookPreffix"
            ></app-native-puff>
          }
          @case (customPostTypeObjectNameEnum.GUIDE) {
            <app-guide-puff
              [forceContentCssClass]="'p-4'"
              [index]="i"
              [numberOfPriorityPuffs]="numberOfPriorityPuffs()"
              [puffDataMultitype]="item"
              [qaHookPreffix]="qaHookPreffix"
            ></app-guide-puff>
          }
          @case (customPostTypeObjectNameEnum.PAGE) {
            <app-page-puff
              *ngIf="item['type'] === customPostTypeObjectNameEnum.PAGE"
              [forceContentCssClass]="'p-4'"
              [index]="i"
              [numberOfPriorityPuffs]="numberOfPriorityPuffs()"
              [puffDataMultitype]="item"
              [qaHookPreffix]="qaHookPreffix"
            ></app-page-puff>
          }
          @default {
            @if (puffType === 'closeby-v2') {
              <app-closeby-provider-card-v2
                [index]="i"
                [puffDataMultitype]="item"
              ></app-closeby-provider-card-v2>
            }
          }
        }
      </div>
    }

    <div class="card-buttons">
      <div (click)="slider.prev()" class="arrow arrow-left shadow-lg">
        <app-ui-icon color="var(--apricot-1)" name="chevron_back"></app-ui-icon>
      </div>
      <div (click)="slider.next()" class="arrow arrow-right shadow-lg">
        <app-ui-icon color="var(--apricot-1)" name="chevron_right"></app-ui-icon>
      </div>
    </div>
  </div>
</div>
